export const SEGMENT_MIN_WIDTH = 21;
